<template>
  <Modal size="lg">
    <div class="modal-header">{{ "give" | translate }}</div>
    <div class="modal-body">
      <div class="alert alert-warning" v-if="validationError">
        {{ validationError }}
      </div>
      <div class="row mb-3">
        <div class="col-3">{{ "to" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            v-model="giveItem.to"
            class="form-control"
            :placeholder="'to' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "comment" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="giveItem.comment"
            :placeholder="'comment' | translate"
          />
        </div>
      </div>

      <h4>{{ "merchandise" | translate }}</h4>

      <div class="row mb-3">
        <div class="col-3">{{ "vendor" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model.number="giveItem.merchandiseVendor"
            :placeholder="'merchandise_vendor' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "merchandise" | translate }}</div>
        <div class="col-9">
          <input
            type="number"
            class="form-control"
            v-model.number="giveItem.merchandiseQuantity"
            :placeholder="'merchandise_quantity' | translate"
          />
        </div>
      </div>
      <part-transaction-list
        :entity="'give' | translate"
        :transactions="giveItem.transactions"
      ></part-transaction-list>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" @click="cancel">
        {{ "cancel" | translate }}
      </button>
      <button class="btn btn-primary" @click="save">
        {{ "save" | translate }}
      </button>
    </div>
  </Modal>
</template>

<script>
import _ from "lodash";
import PartTransactionList from "./PartTransactionList";

export default {
  props: ["editingItem"],
  data() {
    return {
      validationError: null,
      giveItem: {
        to: null,
        merchandiseVendor: null,
        merchandiseQuantity: null,
        transactions: [
          {
            method: null,
            amount: null,
            currency: null
          }
        ],
        comment: null,
        timestamp: new Date().getTime()
      }
    };
  },
  created() {
    if (this.editingItem) {
      this.giveItem = _.cloneDeep(this.editingItem);
    }
  },
  methods: {
    isActive(str) {
      return this.giveItem.type === str;
    },
    setActive(str) {
      this.giveItem.type = str;
    },
    cancel() {
      this.$dismiss();
    },
    save() {
      let item = this.giveItem;
      this.assert(item.to, "to who is required");

      if (!item.merchandiseQuantity) {
        this.assert(
          item.transactions &&
            item.transactions.length &&
            _.every(item.transactions, trans => trans.account && trans.amount),
          "merchandise is reuqired or transaction is required"
        );
      } else {
        this.assert(
          item.merchandiseQuantity,
          "merchandise is reuqired or transaction is required"
        );
      }

      this.$close(item);
    },
    assert(value, message) {
      if (!value) {
        this.validationError = message;
        throw new Error("validation failed: " + message);
      }
    }
  },
  components: { PartTransactionList }
};
</script>
